import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the YyyymmddPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'yyyymmdd',
})
export class YyyymmddPipe implements PipeTransform {

  transform(value: number) {
    if (!value || value === 0) {
      return '-';
    }
    const now = new Date(value * 1000);
    return now.getFullYear() + '/' +  ( "0"+( now.getMonth()+1 ) ).slice(-2)+ '/' + ( "0"+now.getDate() ).slice(-2) + '  ' + ( "0" + now.getHours() ).slice(-2) + ':' + ( "0" + now.getMinutes()).slice(-2);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date/yyyymmdd.ts